export enum FeatureFlag {
  IS_DEVIATION_DETAILS_PAGE_ENABLED = 'IS_DEVIATION_DETAILS_PAGE_ENABLED',
  IS_USERCENTRICS_UI_ENABLED = 'IS_USERCENTRICS_UI_ENABLED',
  NEW_WEEK_STATUSES = 'NEW_WEEK_STATUSES',
  PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED = 'PRO_TALENT_IS_ASSIGNMENT_MANAGEMENT_ENABLED',
  PRO_TALENT_IS_GEOLOCATION_ENABLED = 'PRO_TALENT_IS_GEOLOCATION_ENABLED',
  PRO_TALENT_IS_HIGH_ACCURACY_ENABLED = 'PRO_TALENT_IS_HIGH_ACCURACY_ENABLED',
  PRO_TALENT_IS_LOCATION_SELECTION_ENABLED = 'PRO_TALENT_IS_LOCATION_SELECTION_ENABLED',
  PRO_TALENT_TEST_USERS = 'PRO_TALENT_TEST_USERS',
  PRO_TALENT_IS_PUSH_ENABLED = 'PRO_TALENT_IS_PUSH_ENABLED',
  PRO_IN_APP_CV_CREATION = 'PRO_IN_APP_CV_CREATION',
  PRO_TALENT_IS_CONTENT_CARDS_ENABLED = 'PRO_TALENT_IS_CONTENT_CARDS_ENABLED',
  PRO_TALENT_IS_IN_APP_MESSAGES_ENABLED = 'PRO_TALENT_IS_IN_APP_MESSAGES_ENABLED',
  PRO_ATS = 'PRO_ATS',
  /** Phase 2: the job feed, the listing detail and applying from them. A switch, not an A/B: pro-core reads isEnabled. */
  PRO_JOB_LISTING = 'PRO_JOB_LISTING',
  PRO_TALENT_AVAILABILITY = 'PRO_TALENT_AVAILABILITY',
  PRO_SEMESTER_BREAK = 'PRO_SEMESTER_BREAK',
  /** PJL: the Jobs page as one feed of sections (GET /talent/feed). Off: today's applications block and job feed. */
  PRO_LISTING_FEED = 'PRO_LISTING_FEED',
  /** PJL: applying in three steps (week fit, PRO CV, review) and the tracker's additions. Off: today's confirm sheet. */
  PRO_APPLY_V2 = 'PRO_APPLY_V2'
}
